import { X } from "lucide-react";

import { Modal } from "@/components/modal";

export default function ReportModal({
  isOpen,
  onOpenChange,
  text,
}: {
  isOpen: boolean;
  onOpenChange: () => void;
  text: string;
}) {
  return (
    <Modal
      animate={true}
      classNames={{ modal: "w-x1" }}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <div className="p-6 min-h-50">
        <div className="flex justify-between">
          <p className="font-x1">Feedback</p>
          <X
            className="text-text-tertiary cursor-pointer"
            onClick={onOpenChange}
          />
        </div>
        <p className="text-text-secondary pt-4">{text}</p>
      </div>
    </Modal>
  );
}
